import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Currency from "@components/currency";
import { FormGroup } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormHelperText from "@mui/material/FormHelperText";

function CheckboxModifier({
  modifier,
  modifiedLabel,
  onChange,
  value,
  errors,
}) {
  const checkboxValue = value[modifier.itemId];

  return (
    <Grid item xs={12}>
      <FormControl error={Boolean(errors[modifier.itemId])}>
        <FormGroup>
          <Grid container>
            <Grid item xs={12} key={modifier.itemId}>
              <Typography variant="h2">{modifier.name}</Typography>
              <Typography variant="h4">{modifiedLabel}</Typography>
              {/* {errors[modifier.itemId] && (
                <Typography variant="h6">
                  <FormHelperText>{errors[modifier.itemId]}</FormHelperText>
                </Typography>
              )} */}
            </Grid>

            {modifier.items.map((item, index) => (
              <>
                <Grid item xs={6}>
                  <FormControlLabel
                    value={item.itemId}
                    control={
                      <Checkbox
                        name={`${modifier.itemId}`}
                        onChange={onChange}
                        value={item.itemId}
                        checked={checkboxValue?.includes(`${item.itemId}`)}
                      />
                    }
                    label={item.name}
                  />
                </Grid>
                <Grid item xs={6}>
                  {item.price !== 0 && (
                    <Typography
                      variant="h3"
                      align="right"
                      sx={{ marginTop: "10px" }}
                    >
                      {item.price < 0 ? "-" : "+"}{" "}
                      <Currency value={Math.abs(item.price)} />
                    </Typography>
                  )}
                </Grid>
              </>
            ))}
          </Grid>
        </FormGroup>
        {errors[modifier.itemId] && (
          <FormHelperText>{errors[modifier.itemId]}</FormHelperText>
        )}
      </FormControl>
    </Grid>
  );
}

CheckboxModifier.propTypes = {};

export default CheckboxModifier;
